export default __webpack_public_path__ + "static/media/space-link-icon.0fd7b766.svg";